<div class="orderLandingPage">
  <div class="row headerSection">
    <div class="oti-header-tabs text-left p-0">
      <mat-tab-group disableRipple [animationDuration]="'400ms'" (selectedTabChange)="handleOrderTabChange($event)" class="matTabs orderTabGroup">
        <mat-tab label="Main Tab 1">
          <ng-template mat-tab-label>
            <h4 class="orderTabs mb-0" [ngClass]="activeOrderTab === 0 ? 'activeTab' : ''">ORDER OVERVIEW</h4>
          </ng-template>
        </mat-tab>

        <mat-tab *ngIf="isOiAccess" label="Main Tab 2">
          <ng-template mat-tab-label>
            <h4 class="orderTabs mb-0" [ngClass]="activeOrderTab === 1 ? 'activeTab' : ''">ORDERS - CURRENT AND HISTORY</h4>
          </ng-template>
        </mat-tab>
      </mat-tab-group>

    </div>
    <div class="oti-header-search mx-auto my-md-3 my-0 d-flex justify-content-end" *ngIf="activeOrderTab === 0">
      <div class="input-group withButton">
        <div class="tooltipWrapper">
          <span [ngbTooltip]="myTooltipContent" tooltipClass="infoTooltip" placement="right"
                [triggers]="'click'" class="input-group-addon d-flex" [autoClose]="'outside'" data-tooltip-keep-on-scroll> <i class="far fa-question-circle"></i></span>
        </div>
        <input #ossSearchBox type="text" class="form-control" [placeholder]="searchPlaceHolder" (keyup.enter)="getOtiOrders(true)" (focus)="validateAdvancedSearch(ossSearchBox)" aria-describedby="addon" [(ngModel)]="filter.searchText">
        <span *ngIf="filter.searchText" aria-label="Clear" (click)="clearOSSFilter()" class="input-group-text closeWrapper">
          <i class="fa fa-times"></i>
        </span>
        <span class="input-group-addon" style="cursor:pointer;" id="addon"><button class="keywordHeader" (click)="getOtiOrders(true)" [disabled]="(filter.searchText?.trim()?.length || 0) > 0 && (filter.searchText?.trim()?.length || 0) < 3">Search</button></span>
      </div>
    </div>
    <div class="col-1 my-3 d-flex justify-content-end p-0" *ngIf="activeOrderTab === 0">
      <button class="btn w-100" (click)="openAdvancedSearch()">Advance Search</button>
    </div>
    <div class="col-1 my-3" *ngIf="activeOrderTab === 0">
      <button class="btn w-100" (click)="getExcelReport()">Export</button>
    </div>
  </div>
  <ng-template #myTooltipContent>
    <div class="tab-content-detail">
      <h5 class="font-weight-bold helpText">Search Help</h5>
      <div class="btn-area">
        <div class="keyword-column">
          <h6 class="keywordHeader m-0 pt-2">Keywords</h6>
          <div class="px-3 py-2">
            <p class="mb-2">
              Keyword refers to specific text and our search will try to find the exact keyword
              in the below columns values:
            </p>

            <div class="keyword-table">
              <div class="column">
                <div>Web Order Number</div>
                <div>Order Number</div>
                <div>Customer PO</div>
                <div>Order Date</div>
                <div>Requested Delivery Date</div>
                <div>Order Type</div>
              </div>

              <div class="column divider">
                <div>Product Name</div>
                <div>Account Number</div>
                <div>Account Name</div>
                <div>Account Address</div>
                <div>Account City</div>
                <div>Account State</div>
              </div>

              <div class="column">
                <div>Account Zip Code</div>
                <div>Vendor</div>
                <div>UOM</div>
                <div>Order Status</div>
                <div>Shipment Number</div>
              </div>
            </div>

            <h6 class="keywordHeader">Single Keyword Search</h6>
            <div class="ml-3">
              <p class="m-0 mx-2">Single Keyword search will happen on a minimum of 3 character value. E.g. ab1</p>
              <p class="m-0 mx-2">Spaces in between keyword are considered as single key word. E.g. abc company</p>
              <p class="m-0 mx-2">System ignores spaces before and after a keyword</p>
              <p class="mb-2 mx-2">It will search for a exact matching value ( e.g. "ab1" , " abc company")  in any all of the above parameters columns</p>
            </div>

            <h6 class="keywordHeader">Multiple Keyword Search</h6>
            <div class="ml-3">
              <p class="m-0 mx-2">For multiple keyword search use a  + sign to specify them.  E.g. Shoreview +  abc company</p>
              <p class="m-0 mx-2">System ignores spaces before and after a keyword e.g. "Shoreview&nbsp;&nbsp; + &nbsp;&nbsp;abc company" is same as "Shoreview +  abc company"</p>
              <p class="mb-2 mx-2">Our system will search for a exact matching value "Shoreview" and then " abc company" in sequence across all of the above parameters columns and find records that has all of the keywords.</p>
            </div>
          </div>
        </div>

        <h6 class="pt-3 keywordHeader">Advance Search</h6>
        <div class="mx-3">
          <p class="m-0">Advance search allows you to search for specific values against individual search columns.</p>
          <p class="m-0">Use advance search to get more refined search results.</p>
          <p class="m-0">This will provide the opportunity to search for specific values against individual search columns (specified above)</p>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="newLandingPageOrdersTabSection" *ngIf="activeOrderTab === 0">
    <div class="order-top-sec">
      <div class="">

        <div class="dropdownSectionOne" *ngIf="showHideDateFilter">

          <button mat-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" class="selectDateRange text-left">
            {{filter.dateRangeText}} <i class="arrow down"></i>
          </button>
          <mat-menu #menu="matMenu" class="dropdown-content-new" style="min-width: 176px;">
            <button mat-menu-item (click)="setDateFilter(1,'Last 1 day',1,null)">Last 1 day</button>
            <button mat-menu-item (click)="setDateFilter(1,'Last 7 days',7,null)">Last 7 days</button>
            <button mat-menu-item (click)="setDateFilter(1,'Last 30 days',30,null)">Last 30 days</button>
            <button mat-menu-item (click)="setDateFilter(1,'Last 90 days',90,null)">Last 90 days</button>
            <button mat-menu-item class="btn dropdown-toggle" (click)="$event.stopPropagation();picker.open()">
              Custom:
              <mat-form-field>
                <mat-date-range-input #dateRangeInput [rangePicker]="picker" [min]="minOrderDate" [max]="maxOrderDate">
                  <input matStartDate #startDate matInput placeholder="Start date" [value]="initialStartDate" (dateChange)="setDateFilter(2, 'Custom Date',0, $event)" />
                  <input matEndDate #endDate matInput placeholder="End date" [value]="initialEndDate" (dateChange)="setDateFilter(3,'Custom Date',0, $event)" />
                </mat-date-range-input>

                <mat-date-range-picker #picker [opened]="isPickerOpen" (closed)="onPickerClosed()">
                </mat-date-range-picker>
              </mat-form-field>
            </button>
          </mat-menu>
        </div>

        <div class="dropdownSection">
          <button mat-button #menuStatusTrigger="matMenuTrigger" [matMenuTriggerFor]="menuStatus" class="selectStatus text-left">
            Status : {{filter.orderStatusText}} <i class="arrow down"></i>
          </button>
          <mat-menu #menuStatus="matMenu" class="dropdown-content">
            <button mat-menu-item (click)="setStatusFilter('')">ALL</button>
            <ng-container *ngFor="let status of orderStatusList">
              <button mat-menu-item (click)="setStatusFilter(status.value)">{{status.value}}</button>
            </ng-container>
          </mat-menu>
        </div>
        <div class="dropdownSection" *ngIf="!showHideDateFilter">

        </div>

        <div class="paginatonSection">
          <mat-paginator #otiOrdersPaginator [pageSize]="20" [pageSizeOptions]="[10, 20, 30, 50]"
                         aria-label="Select page of CPP Orders"></mat-paginator>

        </div>
      </div>
    </div>
    <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs margin-t10" (selectedTabChange)="tabChanged($event)" [selectedIndex]="currentTab">
      <mat-tab label="0" *ngIf="isCPPOrderAccess">
        <ng-template mat-tab-label>
          <i class="icon-ico-grower_icon" aria-hidden="true"></i>
          <div class="tab-head">
            <h4 class="tab-head">
              Crop Protection Orders
            </h4>
            <p class="subhead">
              View Your CPP Orders
            </p>

          </div>
          <i class="icon-ico-check" aria-hidden="true"></i>
        </ng-template>
        <div class="tableContainer dealertableContainer col-12">
          <table mat-table [dataSource]="otiOrdersDataSource" multiTemplateDataRows class="matTables newLandingPageTable">

            <ng-container matColumnDef="webOrderNumber">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Web Order Number</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.webOrderNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="orderNumber">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Order Number</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderNumber}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="customerPO">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Customer PO </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.customerPO}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="orderDate">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Order Date </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderDate | date:'MM/dd/yyyy'}}</td>
            </ng-container>

            <ng-container matColumnDef="orderType">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Order Type </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderTypeText}} </td>
            </ng-container>

            <ng-container matColumnDef="productName">
              <th mat-header-cell *matHeaderCellDef class="text-left"> Product</th>
              <td mat-cell *matCellDef="let element" class="text-left">
                <span style="width: 80%;">{{element.productName}}</span>
                <span *ngIf="element.isBIO" style="width: 20%;"><img src="../../../../assets/icon/svg/WU_Bioverified_Green.png" matTooltip="Winfield United Bioverified" [matTooltipPosition]="'above'" /></span>
              </td>
            </ng-container>

            <ng-container matColumnDef="vendor">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Vendor</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.vendor}} </td>
            </ng-container>

            <ng-container matColumnDef="shipToLocation">
              <th mat-header-cell *matHeaderCellDef class="text-left"> Ship-To Location</th>
              <td mat-cell *matCellDef="let element" class="text-left">
                <div class="order-info defaultCursor">
                  <p class="grower-name">
                    {{element.accountName}}
                  </p>
                  <!--<p class="growerAddress">{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>-->
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="orderedQty">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Ordered Qty </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderedQty}} </td>
            </ng-container>

            <ng-container matColumnDef="deliveredQty">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Shipped Qty </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.deliveredQty}} </td>
            </ng-container>

            <ng-container matColumnDef="UOM">
              <th mat-header-cell *matHeaderCellDef class="text-center"> UOM </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.uom}} </td>
            </ng-container>

            <ng-container matColumnDef="orderStatus">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Status </th>
              <td mat-cell *matCellDef="let element" class="text-center pointer" (click)="showDetails(element)"
                  [ngClass]="element.childOrder.length > 1 ? 'greyBg' : addStatusClass(element.orderStatus)">
                {{element.childOrder.length > 1 ? "Split Order" : element.orderStatus}}
                <span *ngIf="element.childOrder.length > 1">
                  <i class="fas fa-sort-down" [ngClass]="element.selected ? 'dropdownArrowOpen' : 'dropdownArrowClose'"></i>
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="trackingURL">
              <th mat-header-cell *matHeaderCellDef class="text-left"> Tracking </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <span style="padding: 11px 15px; float: inline-start;"><a *ngIf="element.trackingURL" href="{{element.trackingURL}}" target="_blank"><img src="../../../../assets/icon/svg/shippingStatus.svg" class="truckImg" alt="truck-image" /></a> </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="addIcon">
              <th mat-header-cell *matHeaderCellDef class="text-left">  </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <span style="background: #c5c5c5; padding: 11px; float: right; "><img src="../../../../assets/icon/svg/flyout.svg" alt="bars-img" class="barsStaggered" (click)="openPopup(element)" /></span>
              </td>
            </ng-container>



            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details2 p-0" *matCellDef="let element" [attr.colspan]="orderColumns.length" [ngStyle]="element.selected ? '':{'display': 'none'}">
                <div class="example-element-detail" [@detailExpand]="element && element.selected ? 'expanded' : 'collapsed'">
                  <table mat-table [dataSource]="element.childOrder" multiTemplateDataRows class="matTables newLandingPageChildTable">
                    <ng-container matColumnDef="webOrderNumber">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.webOrderNumber}} </td>
                    </ng-container>
                    <ng-container matColumnDef="orderNumber">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.orderNumber}} </td>
                    </ng-container>
                    <ng-container matColumnDef="customerPO">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.customerPO}} </td>
                    </ng-container>
                    <ng-container matColumnDef="orderDate">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.orderDate | date:'MM/dd/yyyy'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="orderTypeText">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.orderTypeText}} </td>
                    </ng-container>
                    <ng-container matColumnDef="productName">
                      <td mat-cell *matCellDef="let child" class="text-left"> {{child.productName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="vendor">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.vendor}} </td>
                    </ng-container>

                    <ng-container matColumnDef="shipToLocation">
                      <td mat-cell *matCellDef="let child" class="text-left">
                        <div class="order-info defaultCursor">
                          <p class="grower-name">
                            {{child.accountName}}
                          </p>
                          <!--<p class="growerAddress">{{child.accountAddress1 || child.accountAddress2}}, {{child.accountCity}}, {{child.accountState}} {{child.accountZipCode}}</p>-->
                        </div>
                      </td>
                    </ng-container>


                    <ng-container matColumnDef="orderedQty">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.orderedQty}} </td>
                    </ng-container>

                    <ng-container matColumnDef="deliveredQty">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.deliveredQty}} </td>
                    </ng-container>

                    <ng-container matColumnDef="UOM">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.uom}} </td>
                    </ng-container>

                    <ng-container matColumnDef="orderStatus">
                      <td mat-cell *matCellDef="let child" class="text-center" [ngClass]="addStatusClass(child.orderStatus)">
                        {{child.orderStatus}}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="trackingURL">
                      <td mat-cell *matCellDef="let child" class="text-left">
                        <span style="padding: 11px 15px; float: inline-start;"><a *ngIf="child.trackingURL" href="{{child.trackingURL}}" target="_blank"><img src="../../../../assets/icon/svg/shippingStatus.svg" class="truckImg" alt="truck-image" /></a> </span>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="addIcon">
                      <td mat-cell *matCellDef="let child" class="text-left">
                        <span style="background: #c5c5c5; padding: 11px; float: right; "><img src="../../../../assets/icon/svg/flyout.svg" alt="bars-img" class="barsStaggered" (click)="openPopup(child)" /></span>
                      </td>
                    </ng-container>

                    <tr mat-row *matRowDef="let childRow; columns: childColumns;" style="background: #E9E8E8;"></tr>
                  </table>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="orderColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: orderColumns;"
                class="example-element-row"
                [class.example-expanded-row]="element && element.selected"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
          </table>
          <div *ngIf="otiOrdersDataSource == undefined || otiOrdersDataSource?.data?.length <= 0" class="noDataMsg">
            <p class="padding-b47">No Record Found.</p>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="1" *ngIf="isSeedOrderAccess">
        <ng-template mat-tab-label>
          <i class="icon-ico-grower_icon" aria-hidden="true"></i>
          <div class="tab-head">
            <h4 class="tab-head">
              Seed Orders
            </h4>
            <p class="subhead">
              View Your Seed Orders
            </p>

          </div>
          <i class="icon-ico-check" aria-hidden="true"></i>
        </ng-template>
        <div class="tableContainer seedOrdersTable col-12">
          <table mat-table [dataSource]="otiOrdersDataSource" multiTemplateDataRows class="matTables newLandingPageTable">

            <ng-container matColumnDef="orderNumber">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Order Number</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderNumber}} </td>
            </ng-container>
            <ng-container matColumnDef="customerPO">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Customer PO# </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.customerPO}} </td>
            </ng-container>
            <ng-container matColumnDef="orderDate">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Order Date </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderDate | date:'MM/dd/yyyy'}}</td>
            </ng-container>
            <ng-container matColumnDef="orderType">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Order Type </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderTypeText}} </td>
            </ng-container>
            <ng-container matColumnDef="itemDescription">
              <th mat-header-cell *matHeaderCellDef class="text-left"> Item Description</th>
              <td mat-cell *matCellDef="let element" class="text-left"> {{element.productName}} </td>
            </ng-container>
            <ng-container matColumnDef="marketingBrand">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Marketing Brand</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.vendor}} </td>
            </ng-container>
            <ng-container matColumnDef="shipToLocation">
              <th mat-header-cell *matHeaderCellDef class="text-left"> Ship-To Location</th>
              <td mat-cell *matCellDef="let element" class="text-left">
                <div class="order-info defaultCursor">
                  <p class="grower-name">
                    {{element.accountName}}
                  </p>
                  <!--<p class="growerAddress">{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>-->
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="lotNumber">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Lot Number</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.lotNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="orderedQty">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Ordered Qty </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderedQty}} </td>
            </ng-container>

            <ng-container matColumnDef="deliveredQty">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Delivered Qty </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.deliveredQty}} </td>
            </ng-container>
            <ng-container matColumnDef="orderStatus">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Status </th>
              <td mat-cell *matCellDef="let element" class="text-center pointer"
                  [ngClass]="addStatusClass(element.orderStatus)">
                {{element.orderStatus}}
                <!--<span *ngIf="element.childOrder.length > 1">
                  <i class="fas fa-sort-down" [ngClass]="element.selected ? 'dropdownArrowOpen' : 'dropdownArrowClose'"></i>
                </span>-->
              </td>
            </ng-container>

            <ng-container matColumnDef="trackingURL">
              <th mat-header-cell *matHeaderCellDef class="text-left"> Tracking </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <span style="padding: 11px 15px; float: inline-start;"><a *ngIf="element.trackingURL" href="{{element.trackingURL}}" target="_blank"><img src="../../../../assets/icon/svg/shippingStatus.svg" class="truckImg" alt="truck-image" /></a> </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="addIcon">
              <th mat-header-cell *matHeaderCellDef class="text-left">  </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <span style="background: #c5c5c5; padding: 11px; float: right; "><img src="../../../../assets/icon/svg/flyout.svg" alt="bars-img" class="barsStaggered" (click)="openPopup(element)" /></span>
              </td>
            </ng-container>



            <!--<ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details2 p-0" *matCellDef="let element" [attr.colspan]="seedChildColumns.length" [ngStyle]="element.selected ? '':{'display': 'none'}">
                <div class="example-element-detail" [@detailExpand]="element && element.selected ? 'expanded' : 'collapsed'">
                  <table mat-table [dataSource]="element.childOrder" multiTemplateDataRows class="matTables newLandingPageChildTable">
                    <ng-container matColumnDef="orderNumber">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.orderNumber}} </td>
                    </ng-container>
                    <ng-container matColumnDef="customerPO">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.customerPO}} </td>
                    </ng-container>
                    <ng-container matColumnDef="orderDate">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.orderDate | date:'MM/dd/yyyy'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="orderTypeText">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.orderTypeText}} </td>
                    </ng-container>
                    <ng-container matColumnDef="itemDescription">
                      <td mat-cell *matCellDef="let child" class="text-left"> {{child.productName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="marketingBrand">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.vendor}} </td>
                    </ng-container>

                    <ng-container matColumnDef="shipToLocation">
                      <td mat-cell *matCellDef="let child" class="text-left">
                        <div class="order-info defaultCursor">
                          <p class="grower-name">
                            {{child.accountName}}
                          </p>-->
            <!--<p class="growerAddress">{{child.accountAddress1 || child.accountAddress2}}, {{child.accountCity}}, {{child.accountState}} {{child.accountZipCode}}</p>-->
            <!--</div>
                      </td>
                    </ng-container>


                    <ng-container matColumnDef="lotNumber">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.lotNumber}} </td>
                    </ng-container>

                    <ng-container matColumnDef="orderedQty">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.orderedQty}} </td>
                    </ng-container>

                    <ng-container matColumnDef="deliveredQty">
                      <td mat-cell *matCellDef="let child" class="text-center"> {{child.deliveredQty}} </td>
                    </ng-container>

                    <ng-container matColumnDef="orderStatus">
                      <td mat-cell *matCellDef="let child" class="text-center" [ngClass]="addStatusClass(child.orderStatus)">
                        {{child.orderStatus}}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="trackingURL">
                      <td mat-cell *matCellDef="let child" class="text-left">
                        <span style="padding: 11px 15px; float: inline-start;"><a *ngIf="child.trackingURL" href="{{child.trackingURL}}" target="_blank"><img src="../../../../assets/icon/svg/shippingStatus.svg" class="truckImg" alt="truck-image" /></a> </span>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="addIcon">
                      <td mat-cell *matCellDef="let child" class="text-left">
                        <span style="background: #c5c5c5; padding: 11px; float: right; "><img src="../../../../assets/icon/svg/flyout.svg" alt="bars-img" class="barsStaggered" (click)="openPopup(child)" /></span>
                      </td>
                    </ng-container>

                    <tr mat-row *matRowDef="let childRow; columns: seedChildColumns;" style="background: #E9E8E8;"></tr>
                  </table>
                </div>
              </td>
            </ng-container>-->
            <tr mat-header-row *matHeaderRowDef="seedOrderColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: seedOrderColumns;"
                class="example-element-row"
                [class.example-expanded-row]="element && element.selected"></tr>
            <!--<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>-->
          </table>
          <div *ngIf="otiOrdersDataSource == undefined || otiOrdersDataSource?.data?.length <= 0" class="noDataMsg">
            <p class="padding-b47">No Record Found.</p>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="orderInsightsGridSection" *ngIf="activeOrderTab === 1 && isOiAccess">
    <div class="row ml-0 filtersRow">
      <div class="col-md-10 border m-2 p-3 ng-tns-c4289528800-5 d-flex">

        <!-- PARENT ACCOUNTS -->
        <div class="dropdownSection" *ngIf="filtersSummaryMasterData.parentAccountsList?.length > 2 || filtersSummaryMasterData.parentAccountsList?.length == 0">
          <ng-select [items]="filtersSummaryMasterData.parentAccountsList"
                     bindLabel="value"
                     bindValue="id"
                     placeholder="Parent Account"
                     [multiple]="true"
                     [clearable]="false"
                     [closeOnSelect]="false"
                     [searchable]="false"
                     class="selectStatus text-left">

            <ng-template ng-option-tmp let-item="item">
              <div (click)="toggleItemSelection('parentAccountsList', item.id)" class="d-flex align-items-center">
                <mat-checkbox [checked]="item.selected" disableRipple class="menu-checkbox custom-checkbox select-all-check"></mat-checkbox>
                <span class="menu-label">
                  {{ item.id === 'ALL' ? item.value : (item.id + ' - ' + item.value) }}
                </span>
              </div>
            </ng-template>

            <ng-template ng-label-tmp>
              <span class="dropdown-label">
                Parent Account
                <i class="arrow down"></i>
              </span>
            </ng-template>
          </ng-select>
        </div>

        <!-- LOCATIONS -->
        <div class="dropdownSection">
          <ng-select [items]="filtersSummaryMasterData.locationsList"
                     bindLabel="value"
                     bindValue="id"
                     placeholder="Location"
                     [multiple]="true"
                     [clearable]="false"
                     [closeOnSelect]="false"
                     [searchable]="false"
                     class="selectStatus text-left">

            <ng-template ng-option-tmp let-item="item">
              <div (click)="toggleItemSelection('locationsList', item.id)" class="d-flex align-items-center">
                <mat-checkbox [checked]="item.selected" disableRipple class="menu-checkbox custom-checkbox select-all-check"></mat-checkbox>
                <span class="menu-label">
                  {{ item.id === 'ALL' ? item.value : (item.id + ' - ' + item.value) }}
                </span>
              </div>
            </ng-template>

            <ng-template ng-label-tmp>
              <span class="dropdown-label">
                Location
                <i class="arrow down"></i>
              </span>
            </ng-template>
          </ng-select>
        </div>

        <!-- BRANDS -->
        <div class="dropdownSection">
          <ng-select [items]="filtersSummaryMasterData.brandsList"
                     bindLabel="value"
                     bindValue="id"
                     placeholder="Brand"
                     [multiple]="true"
                     [clearable]="false"
                     [closeOnSelect]="false"
                     [searchable]="false"
                     class="selectStatus text-left">

            <ng-template ng-option-tmp let-item="item">
              <div (click)="toggleItemSelection('brandsList', item.id)" class="d-flex align-items-center">
                <mat-checkbox [checked]="item.selected" disableRipple class="menu-checkbox custom-checkbox select-all-check"></mat-checkbox>
                <span class="menu-label">{{ item.value }}</span>
              </div>
            </ng-template>

            <ng-template ng-label-tmp>
              <span class="dropdown-label">
                Brand
                <i class="arrow down"></i>
              </span>
            </ng-template>
          </ng-select>
        </div>

        <!-- ACTIVE INGREDIENTS -->
        <div class="dropdownSection">
          <ng-select [items]="filtersSummaryMasterData.activeIngredientsList"
                     bindLabel="value"
                     bindValue="id"
                     [multiple]="true"
                     [clearable]="false"
                     placeholder="Active Ingredients"
                     [closeOnSelect]="false"
                     [searchable]="false"
                     class="selectStatus text-left">

            <ng-template ng-option-tmp let-item="item">
              <div (click)="toggleItemSelection('activeIngredientsList', item.id)" class="d-flex align-items-center">
                <mat-checkbox [checked]="item.selected" disableRipple class="menu-checkbox custom-checkbox select-all-check"></mat-checkbox>
                <span class="menu-label">{{ item.value }}</span>
              </div>
            </ng-template>
            <ng-template ng-label-tmp>
              <span class="dropdown-label">
                Active Ingredients
                <i class="arrow down"></i>
              </span>
            </ng-template>
          </ng-select>
        </div>

        <!-- YEAR TYPE (SINGLE SELECT) -->
        <div class="dropdownSection yearType">
          <ng-select [items]="filtersSummaryMasterData.yearTypesList"
                     bindLabel="value"
                     bindValue="id"
                     placeholder="Year Type"
                     [multiple]="false"
                     [clearable]="false"
                     [searchable]="false"
                     [(ngModel)]="selectedYearTypeId"
                     (change)="selectYearType($event)"
                     class="selectStatus material-select text-left">

            <ng-template ng-label-tmp>
              {{ getSelectedYearTypeLabel() }}
            </ng-template>
          </ng-select>
        </div>



        <div class="search-btn mx-2">
          <button mat-raised-button class="btns orderBtn" color="primary" (click)="loadOIPData()">Load</button>
        </div>
        <!--<div class="search-btn">
          <button mat-raised-button class="btns orderBtn" color="primary">Export</button>
        </div>-->
        <div class="clearContainer d-flex align-items-center pl-3">
          <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilters()">Clear All</a>
        </div>
      </div>
    </div>
    <div class="orderInsightsContainer">
      <div class="tab-head d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <img src="../../../../assets/images/Order-Summary.svg" class="summaryIcon" alt="orderHistoryIcon">
          <div class="my-1">
            <h3 class="mb-0">Orders - Current and History</h3>
            <span class="subhead">Compare current Orders with purchases from the last two years</span>
          </div>
        </div>
        <div>
          <mat-paginator #oipOrdersPaginator [pageSize]="20" [pageSizeOptions]="[10, 20, 30, 50]"
                         aria-label="Select page of Order History"></mat-paginator>

        </div>
      </div>
      <div class="orderInsightsTable">
        <table mat-table [dataSource]="orderInsightDataSource" multiTemplateDataRows>

          <ng-container matColumnDef="emptyColumn">
            <th mat-header-cell *matHeaderCellDef colspan="3" class="centered-header"></th>
          </ng-container>

          <ng-container matColumnDef="selectedCurrentYear">
            <th mat-header-cell *matHeaderCellDef colspan="2" class="centered-header">
              <span class="curntYear">{{selectedCurrentYear}}</span>
            </th>
          </ng-container>

          <ng-container matColumnDef="selectedPreviousYear">
            <th mat-header-cell *matHeaderCellDef class="centered-header">{{selectedPreviousYear}}</th>
          </ng-container>

          <ng-container matColumnDef="selectedPreviousYear2">
            <th mat-header-cell *matHeaderCellDef class="centered-header">{{selectedPreviousYear2}}</th>
          </ng-container>

          <ng-container matColumnDef="product">
            <th mat-header-cell *matHeaderCellDef class="text-left headerMiddle">
              <div class="topAlignment">Product</div>
            </th>
            <td mat-cell *matCellDef="let element" class="text-left">
              {{ element.hybridVariety }}
            </td>
          </ng-container>

          <ng-container matColumnDef="packageSize">
            <th mat-header-cell *matHeaderCellDef class="text-left headerMiddle">
              <div class="d-flex justify-content-center align-items-center topAlignment">
                <span class="expandIcon">
                  <i class="fa" [class.fa-plus]="expandedType !== 'packageSize' && expandedType !== 'multiLevel'" [class.fa-minus]="expandedType === 'packageSize' || expandedType === 'multiLevel'"></i>
                </span>
                <span>Package Size</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <button mat-button class="insightBtn" (click)="toggleOrderInsightRow(element, 'packageSize')">
                <img src="../../../../assets/images/Package-Size.svg" alt="dateRangeIcon">
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="dateRange">
            <th mat-header-cell *matHeaderCellDef class="text-left headerMiddle">
              <div class="d-flex justify-content-center align-items-center topAlignment">
                <span class="expandIcon">
                  <i class="fa" [class.fa-plus]="expandedType !== 'dateRange' && expandedType !== 'multiLevel'" [class.fa-minus]="expandedType === 'dateRange' || expandedType === 'multiLevel'"></i>
                </span>
                <span>Date Range</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <button mat-button class="insightBtn" (click)="toggleOrderInsightRow(element, 'dateRange')">
                <img src="../../../../assets/images/Date-Range.svg" alt="dateRangeIcon">
              </button>
              <span></span>
            </td>
          </ng-container>

          <!--<ng-container matColumnDef="uom">
            <th mat-header-cell *matHeaderCellDef class="text-left"> UOM </th>
            <td mat-cell *matCellDef="let element">{{ element.uom }}</td>
          </ng-container>-->

          <ng-container matColumnDef="currentYearOrderedQTY">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Open Order Quantity </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <span>
                {{ element.currentYearOrderedQTY }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="currentYearInvoicedOrShippedQTY">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Shipped/Invoiced Quantity </th>
            <td mat-cell *matCellDef="let element" class="text-center">{{ element.currentYearInvoicedOrShippedQTY }}</td>
          </ng-container>

          <ng-container matColumnDef="previousYearOrderedQTY">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              Invoiced Quantity
            </th>
            <td mat-cell *matCellDef="let element" class="text-center">{{ element.previousYearOrderedQTY }}</td>
          </ng-container>

          <ng-container matColumnDef="previousYear2OrderedQTY">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              Invoiced Quantity
            </th>
            <td mat-cell *matCellDef="let element" class="text-center">{{ element.previousYear2OrderedQTY }}</td>
          </ng-container>

          <!--<ng-container matColumnDef="addToCart">
            <th mat-header-cell *matHeaderCellDef class="text-center">Add to Cart</th>
            <td mat-cell *matCellDef="let element" class="text-center"></td>
          </ng-container>-->

          <ng-container matColumnDef="expandedDetail">
            <td class="p-0" mat-cell *matCellDef="let element" [attr.colspan]="orderInsightsColumns.length">

              <!-- Always present wrapper to enable animation -->
              <div class="example-element-detail bg-grey"
                   [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">

                <!-- Package Size Table -->
                <ng-container *ngIf="expandedType === 'packageSize'">
                  <table mat-table [dataSource]="element.packageSizeLevel" class="orderInsightsChildTable">

                    <ng-container matColumnDef="product">
                      <td mat-cell *matCellDef="let detail">{{ detail.itemNumber }}</td>
                    </ng-container>

                    <ng-container matColumnDef="packageSize">
                      <td mat-cell *matCellDef="let detail" class="packageSizeChild">{{ detail.packageSize }}</td>
                    </ng-container>

                    <ng-container matColumnDef="dateRange">
                      <td mat-cell *matCellDef="let detail"></td>
                    </ng-container>

                    <ng-container matColumnDef="currentYearOrderedQTY">
                      <td mat-cell *matCellDef="let detail">{{ detail.currentYearOrderedQTY }}</td>
                    </ng-container>

                    <ng-container matColumnDef="currentYearInvoicedOrShippedQTY">
                      <td mat-cell *matCellDef="let detail">{{ detail.currentYearInvoicedOrShippedQTY }}</td>
                    </ng-container>

                    <ng-container matColumnDef="previousYearOrderedQTY">
                      <td mat-cell *matCellDef="let detail">{{ detail.previousYearOrderedQTY }}</td>
                    </ng-container>

                    <ng-container matColumnDef="previousYear2OrderedQTY">
                      <td mat-cell *matCellDef="let detail">{{ detail.previousYear2OrderedQTY }}</td>
                    </ng-container>

                    <tr mat-row *matRowDef="let detail; columns: orderInsightsChildColumns"></tr>
                  </table>
                </ng-container>

                <!-- Date Range Table -->
                <ng-container *ngIf="expandedType === 'dateRange'">
                  <table mat-table [dataSource]="element.dateRangeLevel" class="orderInsightsChildTable">

                    <ng-container matColumnDef="product">
                      <td mat-cell *matCellDef="let detail"></td>
                    </ng-container>

                    <ng-container matColumnDef="packageSize">
                      <td mat-cell *matCellDef="let detail"></td>
                    </ng-container>

                    <ng-container matColumnDef="monthName">
                      <td mat-cell *matCellDef="let detail">
                        <div class="monthName">{{ detail.monthName }}</div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="currentYearOrderedQTY">
                      <td mat-cell *matCellDef="let detail">{{ detail.currentYearOrderedQTY }}</td>
                    </ng-container>

                    <ng-container matColumnDef="currentYearInvoicedOrShippedQTY">
                      <td mat-cell *matCellDef="let detail">{{ detail.currentYearInvoicedOrShippedQTY }}</td>
                    </ng-container>

                    <ng-container matColumnDef="previousYearOrderedQTY">
                      <td mat-cell *matCellDef="let detail">{{ detail.previousYearOrderedQTY }}</td>
                    </ng-container>

                    <ng-container matColumnDef="previousYear2OrderedQTY">
                      <td mat-cell *matCellDef="let detail">{{ detail.previousYear2OrderedQTY }}</td>
                    </ng-container>

                    <tr mat-row *matRowDef="let detail; columns: orderInsightsMonthChildColumns"></tr>
                  </table>
                </ng-container>

                <!-- Package Size and Date Range Table -->
                <ng-container *ngIf="expandedType === 'multiLevel'">
                  <table mat-table [dataSource]="packageDateRangeDataSource" class="orderInsightsChildTable" multiTemplateDataRows>

                    <!-- Shared Column Definitions -->
                    <ng-container matColumnDef="product">
                      <td mat-cell *matCellDef="let row">{{ row.isParent ? row.itemNumber : '' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="packageSize">
                      <td mat-cell *matCellDef="let row" class="packageSizeChild">{{ row.isParent ? row.packageSize : '' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="monthName">
                      <td mat-cell *matCellDef="let row"><div class="monthName">{{ !row.isParent ? row.monthName : '' }}</div></td>
                    </ng-container>

                    <ng-container matColumnDef="currentYearOrderedQTY">
                      <td mat-cell *matCellDef="let row">{{ !row.isParent ? row.currentYearOrderedQTY : '' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="currentYearInvoicedOrShippedQTY">
                      <td mat-cell *matCellDef="let row">{{ !row.isParent ? row.currentYearInvoicedOrShippedQTY : '' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="previousYearOrderedQTY">
                      <td mat-cell *matCellDef="let row">{{ !row.isParent ? row.previousYearOrderedQTY : '' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="previousYear2OrderedQTY">
                      <td mat-cell *matCellDef="let row">{{ !row.isParent ? row.previousYear2OrderedQTY : '' }}</td>
                    </ng-container>

                    <!-- Row Definitions -->
                    <tr mat-row *matRowDef="let row; columns: orderInsightsPackageDateRangeColumns; when: isParentRow"></tr>
                    <tr mat-row *matRowDef="let row; columns: orderInsightsPackageDateRangeColumns; when: isChildRow"></tr>
                  </table>
                </ng-container>

              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="groupHeaderRow;sticky:true;"></tr>
          <tr mat-header-row *matHeaderRowDef="orderInsightsColumns;sticky:true;"></tr>
          <tr mat-row *matRowDef="let element; columns: orderInsightsColumns;"
              class="example-element-row"
              [class.example-expanded-row]="expandedElement === element">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        </table>
        <div *ngIf="orderInsightDataSource == undefined || orderInsightDataSource?.data?.length <= 0" class="noDataMsg">
          <p class="padding-b47">No Record Found.</p>
        </div>
      </div>
    </div>
  </div>
</div>
